import { render, staticRenderFns } from "./case-deptor-name.vue?vue&type=template&id=cde46428&scoped=true&"
import script from "./case-deptor-name.vue?vue&type=script&lang=js&"
export * from "./case-deptor-name.vue?vue&type=script&lang=js&"
import style0 from "./case-deptor-name.vue?vue&type=style&index=0&id=cde46428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde46428",
  null
  
)

export default component.exports